/*----------------------------------
- LANDING DOCUMENT OVERLAY STATE
----------------------------------*/

/*----------------------------------
- TYPES
----------------------------------*/

type LandingWindowState = Window & {
	__udLandingScrollLocks?: Set<string>;
	__udLandingScrollTop?: number;
};

/*----------------------------------
- HELPERS
----------------------------------*/

const getLandingWindowState = (): LandingWindowState => window as LandingWindowState;

const getLandingScrollLocks = (): Set<string> => {
	const state = getLandingWindowState();
	if (state.__udLandingScrollLocks) return state.__udLandingScrollLocks;

	state.__udLandingScrollLocks = new Set<string>();
	return state.__udLandingScrollLocks;
};

const lockDocumentScroll = () => {
	const state = getLandingWindowState();
	const scrollTop = window.scrollY || window.pageYOffset || 0;

	state.__udLandingScrollTop = scrollTop;

	document.body.style.position = 'fixed';
	document.body.style.top = `-${scrollTop}px`;
	document.body.style.left = '0';
	document.body.style.right = '0';
	document.body.style.width = '100%';
	document.body.style.overflow = 'hidden';
	document.body.classList.add('ud-landing-scroll-locked');
};

const unlockDocumentScroll = () => {
	const state = getLandingWindowState();
	const scrollTop = state.__udLandingScrollTop ?? 0;

	document.body.classList.remove('ud-landing-scroll-locked');
	document.body.style.position = '';
	document.body.style.top = '';
	document.body.style.left = '';
	document.body.style.right = '';
	document.body.style.width = '';
	document.body.style.overflow = '';

	window.scrollTo({
		top: scrollTop,
		behavior: 'auto',
	});
};

/*----------------------------------
- EXPORTS
----------------------------------*/

export const setLandingBodyClass = (className: string, enabled: boolean) => {
	if (typeof document === 'undefined') return;
	document.body.classList.toggle(className, enabled);
};

export const setLandingDocumentScrollLocked = (lockId: string, locked: boolean) => {
	if (typeof window === 'undefined' || typeof document === 'undefined') return;

	const scrollLocks = getLandingScrollLocks();

	if (locked) {
		if (scrollLocks.has(lockId)) return;
		if (scrollLocks.size === 0) lockDocumentScroll();
		scrollLocks.add(lockId);
		return;
	}

	if (!scrollLocks.has(lockId)) return;
	scrollLocks.delete(lockId);
	if (scrollLocks.size === 0) unlockDocumentScroll();
};
